<!-- Back Button Section -->
<div class="flex items-center mb-4">
  <button nz-button nzType="default" (click)="goBack()"
    class="flex items-center transition-all duration-200 hover:bg-gray-100">
    <i nz-icon nzType="arrow-left" class="mr-2"></i>
    Back
  </button>
</div>

<!-- Header Section -->
<div nz-row class="mb-4">
  <div nz-col [nzSpan]="24">
    <nz-card class="shadow-sm">
      <nz-page-header class="p-0">
        <nz-page-header-title class="text-lg font-semibold text-primary">{{node?.[0]}}</nz-page-header-title>
      </nz-page-header>
    </nz-card>
  </div>
</div>

<!-- Filter Controls Section -->
<div nz-row>
  <div nz-col [nzSpan]="24">
    <nz-card class="mb-6 shadow-sm hover:shadow-md transition-all duration-300">
      <div nz-row [nzGutter]="[16, 16]">
        <!-- Date Range Picker -->
        <div nz-col [nzXs]="24" [nzSm]="12" [nzMd]="8" [nzLg]="6">
          <div class="flex items-center">
            <span class="font-medium text-gray-700 w-[90px] whitespace-nowrap">Date Range:</span>
            <div class="w-full">
              <nz-range-picker [(ngModel)]="dateRange" [nzAllowClear]="true" nzFormat="yyyy/MM/dd" nzSeparator="to"
                [nzShowTime]="false" class="w-full" [nzPopupStyle]="{width: '800px'}" [nzInputReadOnly]="false"
                [nzSuffixIcon]="calendarIcon" [nzPlaceHolder]="['Start date', 'End date']">
              </nz-range-picker>
              <ng-template #calendarIcon><i nz-icon nzType="calendar" nzTheme="outline"></i></ng-template>
            </div>
          </div>
        </div>

        <!-- Start Time Picker -->
        <div nz-col [nzXs]="24" [nzSm]="12" [nzMd]="4" [nzLg]="5">
          <div class="flex items-center">
            <span class="font-medium text-gray-700 w-[90px] whitespace-nowrap">Start Time:</span>
            <nz-time-picker [(ngModel)]="timeRange.start" [nzFormat]="'HH:mm'" [nzAllowEmpty]="false"
              [nzUse12Hours]="false" [nzSuffixIcon]="clockIcon" class="w-full" [nzInputReadOnly]="false"
              nzPlaceHolder="Select time">
            </nz-time-picker>
            <ng-template #clockIcon><i nz-icon nzType="clock-circle" nzTheme="outline"></i></ng-template>
          </div>
        </div>

        <!-- End Time Picker -->
        <div nz-col [nzXs]="24" [nzSm]="12" [nzMd]="4" [nzLg]="5">
          <div class="flex items-center">
            <span class="font-medium text-gray-700 w-[90px] whitespace-nowrap">End Time:</span>
            <nz-time-picker [(ngModel)]="timeRange.end" [nzFormat]="'HH:mm'" [nzAllowEmpty]="false"
              [nzUse12Hours]="false" [nzSuffixIcon]="clockIcon" class="w-full" [nzInputReadOnly]="false"
              nzPlaceHolder="Select time">
            </nz-time-picker>
          </div>
        </div>

        <!-- Location Select -->
        <div nz-col [nzXs]="24" [nzSm]="12" [nzMd]="4" [nzLg]="5">
          <div class="flex items-center">
            <span class="font-medium text-gray-700 w-[90px] whitespace-nowrap">Location:</span>
            <nz-select [(ngModel)]="selectedLocation" (ngModelChange)="getAssetByLocation()"
              nzPlaceHolder="Select Location" class="w-full" [nzShowSearch]="true" nzAllowClear>
              <nz-option *ngFor="let location of locations" [nzValue]="location.location_id"
                [nzLabel]="location.display_name">
              </nz-option>
            </nz-select>
          </div>
        </div>

        <!-- Action Button -->
        <div nz-col [nzXs]="24" [nzSm]="12" [nzMd]="4" [nzLg]="3">
          <button nz-button nzType="primary" [nzLoading]="isReportGenerating" (click)="getCount()"
            class="w-full h-[38px] flex items-center justify-center transition-all duration-200 shadow-sm"
            [disabled]="assets.length === 0">
            <i nz-icon nzType="bar-chart" nzTheme="outline" class="mr-2"></i>
            <span>{{ isReportGenerating ? "Loading..." : "Get Count" }}</span>
          </button>
        </div>
      </div>
    </nz-card>
  </div>
</div>

<!-- Chart and Missing Reading Data Section -->
<div nz-row [nzGutter]="24">
  <!-- Generated Chart -->
  <div nz-col [nzXs]="24" [nzLg]="18">
    <nz-card class="h-full shadow-md transition-all duration-300 hover:shadow-lg">
      <div class="bg-primary -mt-6 -mx-6 mb-6 rounded-t-md">
        <h3 class="text-white font-semibold text-lg m-0 p-4 flex items-center">
          <i nz-icon nzType="line-chart" nzTheme="outline" class="mr-2"></i>
          Chart Analysis
        </h3>
      </div>
      <div id="chart"
        class="flex items-center justify-center min-h-[450px] bg-gray-50 rounded-md border border-gray-100">
      </div>
    </nz-card>
  </div>

  <!-- Missing Reading Information -->
  <div nz-col [nzXs]="24" [nzLg]="6" class="mt-6 lg:mt-0">
    <nz-card class="h-full shadow-md transition-all duration-300 hover:shadow-lg">
      <div class="bg-primary -mt-6 -mx-6 mb-6 rounded-t-md">
        <h3 class="text-white font-semibold text-lg m-0 p-4 flex items-center">
          <i nz-icon nzType="exception" nzTheme="outline" class="mr-2"></i>
          Missing Readings
        </h3>
      </div>

      <div nz-row [nzGutter]="[0, 16]">
        <!-- Asset Name Selection -->
        <div nz-col [nzSpan]="24">
          <div class="flex items-center">
            <span class="font-medium text-gray-700 w-[90px] whitespace-nowrap">Asset Name:</span>
            <nz-select [(ngModel)]="selectedAsset" (ngModelChange)="findDeviceEui()" nzPlaceHolder="Select Asset"
              class="w-full" [nzShowSearch]="true" nzAllowClear>
              <nz-option nzValue="" nzLabel="All Assets"></nz-option>
              <nz-option *ngFor="let asset of missingCount" [nzValue]="asset.asset_name" [nzLabel]="asset.asset_name">
              </nz-option>
            </nz-select>
          </div>
        </div>

        <!-- Sensor Type Selection -->
        <div nz-col [nzSpan]="24">
          <div class="flex items-center">
            <span class="font-medium text-gray-700 w-[90px] whitespace-nowrap">Sensor Type:</span>
            <nz-select [(ngModel)]="selectedSensorType" (ngModelChange)="findDeviceEui()" nzPlaceHolder="Select Type"
              class="w-full" [nzShowSearch]="true" nzAllowClear>
              <nz-option nzValue="" nzLabel="All Types"></nz-option>
              <nz-option nzValue="hot spot" nzLabel="Hotspot"></nz-option>
              <nz-option nzValue="cold spot" nzLabel="ColdSpot"></nz-option>
            </nz-select>
          </div>
        </div>
      </div>

      <!-- Timestamp Data Table -->
      <div class="mt-5 max-h-[350px] overflow-y-auto border border-gray-100 rounded shadow-sm">
        <nz-table #timestampTable [nzData]="timestamp" [nzShowPagination]="false" nzSize="small">
          <thead>
            <tr>
              <th class="bg-gray-100 text-gray-700 font-semibold py-2 px-4 border-b">Count</th>
              <th class="bg-gray-100 text-gray-700 font-semibold py-2 px-4 border-b">Timestamp</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let t of timestamp" class="hover:bg-blue-50 transition-colors duration-150">
              <td class="py-2 px-4 border-b border-gray-100">{{ t.elapsedTime }}</td>
              <td class="py-2 px-4 border-b border-gray-100">{{ t.time }}</td>
            </tr>
          </tbody>
        </nz-table>
      </div>
    </nz-card>
  </div>
</div>